import store from '@/store'
import { Currency } from '@/entities/Currency'
import { Station } from '@/entities/Station'
import { AccountDetails } from '@/entities/AccountDetails'
import { Profile } from '@/entities/Profile'
import { Room } from '@/entities/Room'
import { PaymentMethod } from '@/entities/PaymentMethod'
import { Booking } from '@/entities/Booking'
import { Guest } from '@/entities/Guest'
import { Facility } from '@/entities/Facility'
import { ExchangeRate } from '@/entities/ExchangeRate'
import { ProfileCategory } from '@/entities/ProfileCategory'
import { API_ROOT, EXTENSION_API_ROOT } from '@/config/environment'

export class RequestService {
  listCurrencies () {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/currencies`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(data.body.map(item => new Currency(item)))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  listExchangeRates (currencyId) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/currencies/${currencyId}/exchange-rates`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(data.body.map(item => new ExchangeRate(item)))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  listFacilities () {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/facilities`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(data.body.map(item => new Facility(item)))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  listPaymentMethods () {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/payment-methods`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(data.body.map(item => new PaymentMethod(item)))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getBookingRooms (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/bookings/${id}/rooms`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(data.body.map(item => {
              return {
                room: new Room(item.room),
                account: item.account
              }
            }
            ))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getBookingGuests (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/bookings/${id}/guests`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(data.body.map(item => new Guest(item)))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getBooking (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/bookings/${id}`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new Booking(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getGuest (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/guests/${id}`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new Guest(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  createProfile (profileData) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .post(`${API_ROOT}/profiles`,
          profileData,
          {
            headers: { 'x-api-key': store.state.token }
          })
        .then(
          data => {
            resolve(data.body)
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getAccount (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/accounts/${id}`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new AccountDetails(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  createBooking (bookingData) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .post(`${API_ROOT}/bookings`,
          bookingData,
          {
            headers: { 'x-api-key': store.state.token }
          })
        .then(
          data => {
            resolve(data.body)
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getRoom (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/rooms/${id}`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new Room(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getProfile (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/profiles/${id}`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new Profile(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getProfileCategory (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/profile-categories/${id}`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new ProfileCategory(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  createGuest (guestData) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .post(`${API_ROOT}/guests`,
          guestData,
          {
            headers: { 'x-api-key': store.state.token }
          })
        .then(
          data => {
            resolve(data.body)
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getFacility (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/facilities/${id}`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new Facility(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  getStation (id) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/stations/${id}`, {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new Station(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  createTransaction (transactionData) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .post(`${API_ROOT}/transactions`,
          transactionData,
          {
            headers: { 'x-api-key': store.state.token }
          })
        .then(
          data => {
            resolve(data.body)
          },
          error => {
            reject(error)
          }
        )
    })
  }

  postTransactions (transactions) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .post(`${EXTENSION_API_ROOT}/points-purchase`, transactions.map((t) => { return t.serialize() }), {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(new Facility(data.body))
          },
          error => {
            reject(error)
          }
        )
    })
  }

  whoAmI () {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .get(`${API_ROOT}/whoami`,
          {
            headers: { 'x-api-key': store.state.token }
          })
        .then(
          data => {
            resolve(data.body)
          },
          error => {
            reject(error)
          }
        )
    })
  }
  async lambdaDaypass (req) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http.post(`${EXTENSION_API_ROOT}/daypass`,
        req,
        {
          headers: { 'x-api-key': store.state.token }
        })
        .then(
          data => {
            resolve(data.body)
          },
          error => {
            reject(error)
          }
        )
    })
  }
  saveSignature (body) {
    return new Promise(async (resolve, reject) => {
      window.vm.$http
        .post(`${EXTENSION_API_ROOT}/signature`,
          body,
          {
            headers: { 'x-api-key': store.state.token }
          })
        .then(
          data => {
            resolve(data.body)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
